import { useContext, useMemo } from 'react';

import { SankeyDataContext } from '../context/SankeyData.context.js';
import { SankeyNodesContext } from '../context/SankeyNodes.context.js';
import type { SankeyLayoutModel } from '../types/sankey-internal.js';
import { generateSankeyLayout } from '../utils/generate-sankey-layout.js';

/**
 * Generates the sankey layout for an explicit pixel area.
 *
 * The dimensions are passed in rather than read from the graph-size context
 * because the layout must match the center canvas column — not the full graph
 * area — so rendering and hit-testing share one coordinate space.
 */
export function useGenerateSankeyLayout(
  width: number,
  height: number,
): SankeyLayoutModel {
  const graph = useContext(SankeyDataContext);
  const nodesConfig = useContext(SankeyNodesContext);

  return useMemo(
    () =>
      generateSankeyLayout(
        graph,
        width,
        height,
        nodesConfig.width,
        nodesConfig.alignment,
      ),
    [graph, width, height, nodesConfig.width, nodesConfig.alignment],
  );
}
